import { Component, ViewChild } from '@angular/core';
// HIS
import { HisSearchResultComponent, HisSearchFormComponent } from 'hisng';

@Component( {
    selector: 'psv-person-search-result',
    templateUrl: './person-search-result.component.html'
} )
export class PersonSearchResultComponent {

    @ViewChild( HisSearchResultComponent, { static: true } ) searchResultComponent: HisSearchResultComponent;
}
